import { useState } from "react";
import { FileText, Inbox, User } from "lucide-react";
import TemplatesList from "./templates/TemplatesList";
import PerfilForm from "./perfil/PerfilForm";
import InboxLayout from "./inbox/InboxLayout";

const TABS = [
  { id: "templates", label: "Templates", Icon: FileText },
  { id: "perfil",    label: "Perfil",    Icon: User },
  { id: "inbox",     label: "Inbox",     Icon: Inbox },
];

export default function TabsContaConectada({ conta, socket }) {
  const [active, setActive] = useState("templates");

  if (!conta?.id) return null;

  return (
    <div className="mt-6">
      <div className="flex items-center border-b border-white/[0.06]">
        {TABS.map(({ id, label, Icon }) => {
          const isActive = active === id;
          return (
            <button
              key={id}
              onClick={() => setActive(id)}
              className={`inline-flex items-center gap-2 px-4 py-2.5 text-sm font-medium border-b-2 transition ${
                isActive
                  ? "border-brand-500 text-white"
                  : "border-transparent text-ink-3 hover:text-ink-2"
              }`}
            >
              <Icon className="w-4 h-4" /> {label}
            </button>
          );
        })}
      </div>

      <div className="pt-6">
        {active === "templates" && <TemplatesList contaId={conta.id} socket={socket} />}
        {active === "perfil" && <PerfilForm contaId={conta.id} />}
        {active === "inbox" && <InboxLayout contaId={conta.id} socket={socket} />}
      </div>
    </div>
  );
}
